import React from 'react'
import './loaders.css';

export default function SkeletonLoader() {
	return <div className="placeholder-item" />
}
